
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oranges/shop/[category]",
      function () {
        return require("private-next-pages/oranges/shop/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/oranges/shop/[category]"])
      });
    }
  